import { ModeloBase } from './modeloBase';

export class ModeloFamiliaSubgrupo extends ModeloBase {
    cod_familia_subgrupo!: number;
    des_familia_subgrupo!: string; 
}
